<app-dialog [size]="DialogSize.SMALL" type="confirmation">
  <app-dialog-header [showClose]="false">
    <h2>{{ data.header }}</h2>
  </app-dialog-header>

  <p class="body-300 color-gray-400 ta--center mt-2">
    Please <strong>do not navigate away or close the browser window</strong> until authentication is completed or canceled.
  </p>

  <app-dialog-footer [showCancel]="false" [equalWidthButtons]="true">
    <button andButton size="large" [mat-dialog-close]="false">Cancel Payment</button>
    <button andButton size="large" color="primary" [mat-dialog-close]="true" class="ms-3">Continue Payment</button>
  </app-dialog-footer>
</app-dialog>
